import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { setCartModal } from "../../features/addToCartSlice";
import { logOutUser } from "../../features/authSlice";
import Cart from "../Common/Cart";
import { ApiCall } from "../../EnvConfig/env_config";
import { toast } from 'react-toastify';
import { countryEsim, reginoalEsim } from "../../features/commonSlice";
/*import { countryEsim, reginoalEsim } from "../../features/commonSlice";*/

const Header = () => {
    const [buyEsimToggle, setBuyEsimToggle] = useState(false)
    const [buyregionalEsimToggle, setbuyregionalEsimToggle] = useState(false)
    const [loginToggle, setLoginToggle] = useState(false)
    const [OpenMenu, setOpenMenu] = useState(false)
    const [profileopen, setProfileopen] = useState(false)
    const [isFixed, setIsFixed] = useState(false);
    const dispatch = useDispatch()
    const cartModal = useSelector((state) => state.addToCartDetails.cartModal)
    const authEmail = localStorage.getItem('emailID')
    const authLoginToken = localStorage.getItem('loginToken')
    const authLoginUserCode = localStorage.getItem('loginUserCode')
    const userName = localStorage.getItem('userName')
    const [countryData, setCountryData] = useState([])
    const [RegionalData, setRegionalData] = useState([])
    const { cart } = useSelector(state => state.addToCartDetails)
    const profileDropdownRef = useRef(null);
    const buyEsimDropdownRef = useRef(null);
    const buyRegionalEsimDropdownRef = useRef(null);
    const partnerDropdownRef = useRef(null);

    const navigate = useNavigate()

   
    const getCountryDetails = async () => {
        //dispatch(countryEsim(tempV.countryDetails))
        try {
            const response = await ApiCall(`/api/Web/BuyEsim`);
            if (response.status === "SUCCESS") {
                await setCountryData(response.countryDetails)
                dispatch(countryEsim(response.countryDetails))
            } else if (response.status === 'ERROR') {
                setCountryData([])
              dispatch(countryEsim([]))
            }
        } catch (error) {
            toast.error('There was a problem with the server, Please try after sometimes.');
        }
    }

    const getRegionalDetails = async () => {
        try {
            const response = await ApiCall(`/api/Web/RegionalEsim`);
            if (response.status === "SUCCESS") {
                await setRegionalData(response.regionNameLists)
                dispatch(reginoalEsim(response.regionNameLists))
            } else if (response.status === 'ERROR') {
                setRegionalData([])
                dispatch(reginoalEsim([]))
            }
        } catch (error) {
            toast.error('There was a problem with the server, Please try after sometimes.');
        }
    }

    useEffect(() => {
        const handleClickOutside = (event) => {

            if (buyEsimDropdownRef.current && !buyEsimDropdownRef.current.contains(event.target)) {
                setBuyEsimToggle(false);
            }
            if (buyRegionalEsimDropdownRef.current && !buyRegionalEsimDropdownRef.current.contains(event.target)) {
                setbuyregionalEsimToggle(false);
            }
            if (profileDropdownRef.current && !profileDropdownRef.current.contains(event.target)) {
                setProfileopen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [profileopen, buyEsimToggle]);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setIsFixed(true);
            } else {
                setIsFixed(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        getCountryDetails()
        getRegionalDetails()

    }, [])

    return (
        <>
            <div className='topbar primary-bg py-1'>
                <p className='m-0 text-white'>Get <span style={{ color: '#fbec5d' }} className='fw-bold'>50% off</span> on every eSIM & add-on plan</p>
                <Link to='/destinations' className='mybtn secondary-bg wiggle-btn py-1'>Grab Now</Link>
        </div>
        <nav className={`navbar navbar-expand-lg navbar-light bg-white shadow-sm ${isFixed ? 'fixed' : ''}`}>
            <div className="container-fluid position-relative" style={{ width: "100%" }}>
                <a className="navbar-brand fw-bold p-0 primary-text" href="/"><img src='./assets/images/logo_final.svg' alt='logo' /></a>
                <div className={`d-block d-lg-none navbar-toggler order-last ${OpenMenu ? 'show' : 'hide'}`} onClick={() => setOpenMenu(!OpenMenu)}>
                    <span></span>
                    <span></span>
                    <span></span>
                    {/*<i className="fs-1 bi bi-list"></i>*/}
                </div>
                <div className={`collapse navbar-collapse ${OpenMenu ? 'left_open' : ''}`} id="navbarNav">
                    <a className="navbar-brand fw-bold p-3 primary-text d-md-none" href="/"><img src='./assets/images/logo_final.svg' alt='logo' /></a>
                    <ul className="navbar-nav me-5 ms-auto">
                        <li className="nav-item ms-3">
                            <NavLink onClick={() => setOpenMenu(false)} className="nav-link" to="/"><i className="bi bi-house"></i>Home</NavLink>
                        </li>
                        <li className="nav-item ms-3 position-relative" ref={buyEsimDropdownRef}>
                            <a
                                onClick={() => {
                                    setBuyEsimToggle(!buyEsimToggle)
                                    setProfileopen(false)
                                    dispatch(setCartModal(false))

                                }} className="nav-link" id="buysim"><i className="bi bi-sim"></i>Popular Countries esim <i className={`bi arrow_caret d-inline-block ${buyEsimToggle ? 'bi-caret-down-fill' : 'bi-caret-right-fill'} `}></i></a>
                            <div className={`dropdown_item ${buyEsimToggle ? 'show' : ''}`}>
                                <ul className='list-unstyled d-md-flex flex-wrap'>
                                    {
                                        countryData?.map((item, index) => <li key={index }>
                                            <Link onClick={() => {
                                                setBuyEsimToggle(false)
                                                setOpenMenu(false)
                                            }} to={`/esim-plans/${item.country}`}>
                                                <img style={{ height: "20px", width: "25px", objectFit: "cover", marginRight: "10px" }} src={item?.countryFlagBase64} alt={`${item.country}`} />
                                                {item.country}</Link>
                                        </li>)
                                    }
                                    <li>
                                        <Link to={`/destinations`} onClick={() => {
                                            setBuyEsimToggle(false)
                                            setOpenMenu(false)
                                        }
                                        }>View All Destination</Link>

                                    </li>
                                </ul>
                            </div>
                        </li> 
                        <li className="nav-item ms-3 position-relative " ref={buyRegionalEsimDropdownRef}>
                            <a
                                onClick={() => {
                                    setbuyregionalEsimToggle(!buyregionalEsimToggle)
                                    setProfileopen(false)
                                    dispatch(setCartModal(false))

                                }} className="nav-link d-flex align-items-center" id="Regionalsim"><i className="bi bi-sim"></i>Regional esim <i className={`bi arrow_caret d-inline-block ${buyregionalEsimToggle ? 'bi-caret-down-fill' : 'bi-caret-right-fill'} `}></i></a>
                            <div className={`dropdown_item ${buyregionalEsimToggle ? 'show' : ''}`}>
                                <ul className='list-unstyled d-md-flex flex-wrap'>
                                    {
                                        RegionalData?.map((item, index) => <li key={index}>
                                            <Link onClick={() => {
                                                setbuyregionalEsimToggle(false)
                                                setOpenMenu(false)
                                            }} to={`/esim-plans/${item.regionName}`}>
                                                {item.regionName}</Link>
                                        </li>)
                                    }
                                </ul>
                            </div>
                        </li>
                        <li className="nav-item ms-3">
                            <NavLink onClick={() => setOpenMenu(false)} className="nav-link" to="/add-on-plans" ><i className="bi bi-file-earmark-person"></i>Add On Plans</NavLink>
                        </li>
                        <li className="nav-item ms-3 position-relative" ref={partnerDropdownRef}>
                            <NavLink onClick={() => setOpenMenu(false)} className="nav-link" to='/simfly-new-partner-platform' ><i className="bi bi-people"></i>Partner with us</NavLink>
                        </li>
                        <li className="nav-item ms-3">
                            <NavLink onClick={() => setOpenMenu(false)} className="nav-link" to="/aboutus" ><i className="bi bi-file-earmark-person"></i>About Us</NavLink>
                        </li>
                        <li className="nav-item ms-3">
                            <NavLink onClick={() => setOpenMenu(false)} className="nav-link" to="/contactus"><i className="bi bi-headset"></i>Contact Us</NavLink>
                        </li>
                        <li className="nav-item ms-3">
                            <NavLink onClick={() => setOpenMenu(false)} className="nav-link" to="/FAQs"><i className="bi bi-question-lg"></i>FAQs</NavLink>
                        </li>
                    </ul>
                </div>
                <div className="left_nav ms-auto">
                    <ul className="m-0 p-0 list-unstyled d-flex align-items-center gap-2">
                        {/* <li className='d-lg-none'>
                            <Link to='/'><i className="bi bi-house"></i></Link>
                        </li> */}
                        <li className="position-relative">
                            <a className={`cta_hover ${cartModal ? 'active' : ''}`}
                                onClick={() => {
                                    setBuyEsimToggle(false)
                                    setProfileopen(false)
                                    dispatch(setCartModal(cartModal ? false : true))
                                }}
                            ><i className="bi bi-cart2"></i>
                                <div className={`badge ${cartModal ? 'bg-white' : 'primary-bg text-white'}`}>{cart?.length !== "0" ? cart?.length : '0'}</div>
                            </a>
                                <Cart carttoggle={cartModal} />
                        </li>
                        {
                            authEmail !== null && authLoginToken !== null && authLoginUserCode !== null ?
                                <li className="position-relative" ref={profileDropdownRef}>
                                    <Link
                                        onClick={() => {
                                            setBuyEsimToggle(false)
                                            setProfileopen(!profileopen)
                                            dispatch(setCartModal(false))
                                        }}
                                        className="text-dark light-bg cta_hover text-truncate d-flex align-items-center"
                                    >
                                        <i className="bi bi-person-circle me-md-2"></i>
                                        {/*<span className="userName text-truncate">{userName ? userName : ''}</span>*/}
                                        <i className={`ms-2 bi d-none d-lg-block ${profileopen ? 'bi-chevron-up' : 'bi-chevron-down'} `}></i>
                                    </Link>
                                    <div className={`profile_dropdown p-0 pb-3 ${profileopen ? 'show' : ''}`}>
                                        {
                                            userName &&
                                                <div className="border-bottom px-3 py-2 d-flex align-items-center gap-3">
                                                    <div className="pulsating-dot positive"></div>
                                                    <span className="userName text-truncate">{userName}</span>
                                                </div>
                                        }
                                        
                                        <div className="px-3">
                                            <Link className="mt-2" onClick={() => setProfileopen(false)} to='/profile'>Account Information</Link>
                                            {/*<Link onClick={() => setProfileopen(false)} to=''>Airmoney & Membership</Link>*/}
                                            {/*<Link onClick={() => setProfileopen(false)} to=''>Saved Cards</Link>*/}
                                            {/*<Link onClick={() => setProfileopen(false)} to=''>Refer & Earn</Link>*/}
                                            {/*<Link onClick={()=> setProfileopen(false)} to=''>Orders</Link>*/}
                                            <button onClick={() => {
                                                dispatch(logOutUser())
                                                navigate("/")
                                            }} className="mybtn secondary-bg text-dark w-100 mt-2">logout</button>
                                        </div>
                                    </div>
                                </li>
                                : <li className='position-relative'>
                                    <Link className="mybtn secondary-bg text-dark d-none d-lg-block" onClick={() => setLoginToggle(!loginToggle)}>Login</Link>
                                    <div className={`profile_dropdown p-3 ${loginToggle ? 'show' : ''}`}>
                                        <ul className='list-unstyled text-md-start text-center'>
                                            <li><Link to='/login' onClick={() => setLoginToggle(false)}><i className="bi bi-person-fill fs-6 primary-text me-2"></i>Customer Login</Link></li>
                                            <li><Link target="_blank" to='https://affiliate.simfly.co.in/' onClick={() => setLoginToggle(false)}><i className="bi bi-people-fill me-2 primary-text fs-6"></i>Partner Login</Link></li>
                                        </ul>
                                    </div>
                                    <Link onClick={() => setLoginToggle(!loginToggle)} className="d-lg-none"><i className="bi bi-person"></i></Link>
                                </li>
                        }
                    </ul>
                </div>
            </div>
                    <div className={`login_overlay ${!loginToggle ? 'd-none' : 'd-block'}`}></div>
            </nav>
        </>
    )
}

export default Header;